var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.5C19 8.88071 17.8807 10 16.5 10C15.1193 10 14 8.88071 14 7.5C14 6.11929 15.1193 5 16.5 5C17.8807 5 19 6.11929 19 7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5C1.25 2.92893 2.92893 1.25 5 1.25H19C21.0711 1.25 22.75 2.92893 22.75 5V19C22.75 21.0711 21.0711 22.75 19 22.75H5C2.92893 22.75 1.25 21.0711 1.25 19V5ZM5 2.75C3.75736 2.75 2.75 3.75736 2.75 5V14.75L6.98117 10.5188C7.8019 9.6981 9.14659 9.74607 9.90676 10.6232L14.3036 15.6964L15.5858 14.4142C16.3668 13.6332 17.6332 13.6332 18.4142 14.4142L21.25 17.25V5C21.25 3.75736 20.2426 2.75 19 2.75H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.acea315d2b5d6bacabc9b840660e5d64.svg";
export { ForwardRef as ReactComponent };